import { t } from "@/i18n-js/instance";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { Modal } from "@circle-react-uikit/ModalV2";
import { PaywallInfoModalContent } from "./PaywallInfoModalContent";

const localeRoot = "community_onboarding.new_checklist.paywall_info_modal";

const PaywallInfoModalComponent = () => {
  const modal = useModal();

  const handleOnClose = async () => {
    await modal.hide();
    modal.remove();
  };

  return (
    <Modal isOpen={modal.visible} onClose={handleOnClose}>
      <Modal.Overlay />
      <Modal.Content size="lg">
        <Modal.Header>
          <Modal.Title size="md">{t(`${localeRoot}.title`)}</Modal.Title>
          <Modal.HeaderActions>
            <Modal.CloseButton onClick={handleOnClose} />
          </Modal.HeaderActions>
        </Modal.Header>
        <Modal.Body>
          <PaywallInfoModalContent />
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};

const PaywallInfoModal = ModalManager.create(() => (
  <PaywallInfoModalComponent />
));

export const usePaywallInfoModal = () => useModal(PaywallInfoModal);
